export const RandomCat = () => {
  return (
    <>
      <h1>Random Cats</h1>
    </>
  );
};
